export function getView(type) {
  switch (type) {
    case 'STRING':
      return 'StringInput'
    case 'NUMBER':
      return 'NumberInput'
    case 'BOOLEAN':
      return 'BooleanInput'
    case 'DATE':
      return 'DateInput'
    default:
      return 'No'
  }
}
